export default function getRedirectQueryString(redirectPath?: string) {
  const finalPath =
    redirectPath || window.location.href.replace(window.location.origin, '');

  if (!finalPath || finalPath === '/') return '';

  const searchParams = new URLSearchParams();
  searchParams.set('redirect', finalPath);
  return `?${searchParams.toString()}`;
}
